export class UCuencaError extends Error {

  status?: number;  
  handled = false;
  

  constructor(message?: string, status?: number) {
    super(message);
    this.name = UCuencaError.name;
    this.status = status;
    Object.setPrototypeOf(this, UCuencaError.prototype);
  }

  
}